import {Karen} from "../Karen";
import {KarenLayers, Layers} from "./KarenLayers";
import {Bounce, TimelineLite, TweenLite} from "gsap";
import {KarenSoundManager} from "../sound/KarenSoundManager";
import {KarenSoundConfig} from "../sound/KarenSoundConfig";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

/**
 * Created by Vishnu Todwal on 2021-02-09.
 */
export interface IFrame {
    topFrame: PIXI.Sprite,
    botFrame: PIXI.Sprite
}

export class KarenReelBackground extends PIXI.Container {
    private _reelBackground: PIXI.Sprite;
    private _reelTop6Frame: PIXI.Sprite;
    private _reelTop5Frame: PIXI.Sprite;
    private _reelTop4Frame: PIXI.Sprite;
    private _reelTop3Frame: PIXI.Sprite;
    private _reelBottom6Frame: PIXI.Sprite;
    private _reelBottom5Frame: PIXI.Sprite;
    private _reelBottom4Frame: PIXI.Sprite;
    private _reelBottom3Frame: PIXI.Sprite;
    private _defaultSymbolsSize: number[] = [2, 3, 3, 3, 3, 3];
    private _bottomReelFramePosition: [number, number][] = [[268, 313], [388, 280], [508, 236], [628, 195]];
    private _topReelFramePosition: [number, number][] = [[268, 70], [388, 70], [508, 70], [628, 70]];

    constructor() {
        super();
        this.init();
        KarenLayers.getLayer(Layers.REEL_BACKGROUND)?.addChild(this);
    }

    public increaseBounceReelFrame(reelId: number,notAnimate:boolean=false): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        this._defaultSymbolsSize[reelId]++;
        if(notAnimate){
            this.bounceReelFrameWithOutAnimation(reelId, this._defaultSymbolsSize[reelId], true);
        }else {
            tl.add(this.bounceReelFrame(reelId, this._defaultSymbolsSize[reelId], true));
        }
        return tl;
    }

    public bounceReelFrame(reelId: number, reelSize: number, enableOverlay: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let positionOffset: number = (reelSize - 3) * 84;
        let topReelFrame: PIXI.Sprite | undefined;
        let bottomReelFrame: PIXI.Sprite | undefined;
        let topFramePosition: number;
        let bottomFramePosition: number;
        this._defaultSymbolsSize[reelId] = reelSize;
        topReelFrame = this.getReelFrame(reelId).topFrame;
        bottomReelFrame = this.getReelFrame(reelId).botFrame;
        if (topReelFrame instanceof PIXI.Sprite && bottomReelFrame instanceof PIXI.Sprite) {
            topFramePosition = this._topReelFramePosition[reelId - 2][1] - (positionOffset / 2);
            bottomFramePosition = this._bottomReelFramePosition[reelId - 2][1] + (positionOffset / 2);
            if (enableOverlay) {
                tl.add(Karen.reelExpandOverlayView.expandReels(reelId));
            }
            let tl1 = TweenLite.to(topReelFrame, 0.2, {y: topFramePosition, ease: Bounce.easeOut});
            let tl2 = TweenLite.to(bottomReelFrame, 0.2, {y: bottomFramePosition, ease: Bounce.easeOut});
            tl.add([tl1, tl2, () => {
                if (enableOverlay && (reelId > 1 && reelId < 6)) {
                    const soundName: string = KarenSoundConfig.REEL_EXPAND.next();
                    const sound: NolimitHowl | undefined = KarenSoundManager.playSoundEffect(soundName);
                    if (sound) {
                        Logger.logDev("sound: starting Sound", soundName, "for reel:", reelId);
                        sound.player.stereo(KarenSoundManager.davidPanningReelStop[reelId]);
                    }
                }
            }]);
        }
        return tl;
    }
    public bounceReelFrameWithOutAnimation(reelId: number, reelSize: number, enableOverlay: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let positionOffset: number = (reelSize - 3) * 84;
        let topReelFrame: PIXI.Sprite | undefined;
        let bottomReelFrame: PIXI.Sprite | undefined;
        let topFramePosition: number;
        let bottomFramePosition: number;
        this._defaultSymbolsSize[reelId] = reelSize;
        topReelFrame = this.getReelFrame(reelId).topFrame;
        bottomReelFrame = this.getReelFrame(reelId).botFrame;
        if (topReelFrame instanceof PIXI.Sprite && bottomReelFrame instanceof PIXI.Sprite) {
            topFramePosition = this._topReelFramePosition[reelId - 2][1] - (positionOffset / 2);
            bottomFramePosition = this._bottomReelFramePosition[reelId - 2][1] + (positionOffset / 2);
            if (enableOverlay) {
                Karen.reelExpandOverlayView.expandReels(reelId);
            }
            topReelFrame.y =topFramePosition;
            bottomReelFrame.y =bottomFramePosition;
            if (enableOverlay && (reelId > 1 && reelId < 6)) {
                const soundName: string = KarenSoundConfig.REEL_EXPAND.next();
                const sound: NolimitHowl | undefined = KarenSoundManager.playSoundEffect(soundName);
                if (sound) {
                    Logger.logDev("sound: starting Sound", soundName, "for reel:", reelId);
                    sound.player.stereo(KarenSoundManager.davidPanningReelStop[reelId]);
                }
            }
        }
        return tl;
    }

    public isReelExpanded(): boolean {
        let isExpanded: boolean = false;
        for (let idx: number = 2; idx < this._defaultSymbolsSize.length; idx++) {
            if (this._defaultSymbolsSize[idx] > 3) {
                isExpanded = true;
                break;
            }
        }
        return isExpanded;
    }

    private getReelFrame(reelId: number): IFrame {
        let topReelFrame: PIXI.Sprite;
        let bottomReelFrame: PIXI.Sprite;
        switch (reelId) {
            case 2:
                topReelFrame = this._reelTop3Frame;
                bottomReelFrame = this._reelBottom3Frame;
                break;
            case 3:
                topReelFrame = this._reelTop4Frame;
                bottomReelFrame = this._reelBottom4Frame;
                break;
            case 4:
                topReelFrame = this._reelTop5Frame;
                bottomReelFrame = this._reelBottom5Frame;
                break;
            case 5:
                topReelFrame = this._reelTop6Frame;
                bottomReelFrame = this._reelBottom6Frame;
                break;
        }
        return {
            topFrame: topReelFrame!,
            botFrame: bottomReelFrame!
        }
    }

    private init(): void {
        this.position.set(-29, 106);
        this._reelBackground = new PIXI.Sprite(Karen.assetLoader.getTextures("reel_Frame")[0]);
        this._reelTop6Frame = new PIXI.Sprite(Karen.assetLoader.getTextures("reel_frame_tr6")[0]);
        this._reelTop5Frame = new PIXI.Sprite(Karen.assetLoader.getTextures("reel_frame_tr5")[0]);
        this._reelTop4Frame = new PIXI.Sprite(Karen.assetLoader.getTextures("reel_frame_tr4")[0]);
        this._reelTop3Frame = new PIXI.Sprite(Karen.assetLoader.getTextures("reel_frame_tr3")[0]);
        this._reelBottom6Frame = new PIXI.Sprite(Karen.assetLoader.getTextures("reel_frame_br6")[0]);
        this._reelBottom5Frame = new PIXI.Sprite(Karen.assetLoader.getTextures("reel_frame_br5")[0]);
        this._reelBottom4Frame = new PIXI.Sprite(Karen.assetLoader.getTextures("reel_frame_br4")[0]);
        this._reelBottom3Frame = new PIXI.Sprite(Karen.assetLoader.getTextures("reel_frame_br3")[0]);
        this.addChild(this._reelBackground, this._reelBottom6Frame, this._reelBottom5Frame, this._reelBottom4Frame,
            this._reelBottom3Frame, this._reelTop6Frame, this._reelTop5Frame, this._reelTop4Frame, this._reelTop3Frame);
        this.setPosition();
    }

    private setPosition(): void {
        this._reelBottom6Frame.position.set(this._bottomReelFramePosition[3][0], this._bottomReelFramePosition[3][1]);
        this._reelBottom5Frame.position.set(this._bottomReelFramePosition[2][0], this._bottomReelFramePosition[2][1]);
        this._reelBottom4Frame.position.set(this._bottomReelFramePosition[1][0], this._bottomReelFramePosition[1][1]);
        this._reelBottom3Frame.position.set(this._bottomReelFramePosition[0][0], this._bottomReelFramePosition[0][1]);
        this._reelTop6Frame.position.set(this._topReelFramePosition[3][0], this._topReelFramePosition[3][1]);
        this._reelTop5Frame.position.set(this._topReelFramePosition[2][0], this._topReelFramePosition[2][1]);
        this._reelTop4Frame.position.set(this._topReelFramePosition[1][0], this._topReelFramePosition[1][1]);
        this._reelTop3Frame.position.set(this._topReelFramePosition[0][0], this._topReelFramePosition[0][1]);
    }
}
